import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Badge } from "../../../Component/AdminComponents/Badge";
import { SectionCard } from "../../../Component/AdminComponents/SectionCard";
import { BASE_URL } from "../../../config/api";
import SimpleTable from "../../../Component/Common/SimpleTable";
import RefreshButton from "../../../Component/Common/RefreshButton";
import RegularLoader from "../../../Component/Loader/RegularLoader";

export default function RetailerUsersView({entityType,entityId}) {
  const authUser = JSON.parse(localStorage.getItem("authUserData"));
  const role = Number(authUser?.role);
  const companyId = authUser?.id;

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [updatingId, setUpdatingId] = useState(null);

  /* ---------------- FETCH USERS ---------------- */
  const fetchUsers = async (page = 1) => {
  try {
    setLoading(true);

    let url = `${BASE_URL}common/get-users?role=6&page=${page}`;

    // 🔹 Admin / Company viewing a retailer → filter by retailer_id
    if (entityType === "retailer" && entityId) {
      url += `&retailer_id=${entityId}`;
    }

    // 🔹 Company logged in (fallback)
    else if (role === 2 && companyId) {
      url += `&company_id=${companyId}`;
    }

    const res = await axios.get(url);

    if (res.data?.status) {
      setUsers(res.data.data || []);
      setCurrentPage(res.data.pagination?.current_page || 1);
      setTotalPages(res.data.pagination?.last_page || 1);
    } else {
      setUsers([]);
    }
  } catch (err) {
    console.error("Failed to load retailer users", err);
    setUsers([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
  fetchUsers(currentPage);
}, [role, companyId, entityType, entityId, currentPage]);

  /* ---------------- TOGGLE STATUS (UI ONLY) ---------------- */
  const handleToggleUserStatus = async (user) => {
    try {
      setUpdatingId(user.id);

      const newStatus = user.status === 1 ? 0 : 1;

      await axios.post(`${BASE_URL}company/status/${user.id}`, {
        status: newStatus,
      });

      setUsers((prev) =>
        prev.map((u) =>
          u.id === user.id ? { ...u, status: newStatus } : u
        )
      );
    } catch (err) {
      console.error(err);
    } finally {
      setUpdatingId(null);
    }
  };

  /* ---------------- TABLE ROWS ---------------- */
  const rows = useMemo(
    () =>
      users.map((u) => {
        const statusLabel = u.status === 1 ? "Active" : "Inactive";

        return {
          raw: u,
          cells: [
            {
              title: u.owner_email || u.contact_email || "-",
              sub: u.owner_contact || u.contact_phone || "",
            },
            {
              title: u.business_name || "-",
              sub: u.company_code || "",
            },
            "Retailer User",
            {
              title: u.created_by_name || u.contact_email || "-",
              sub: u.parent?.company_code || u.contact_phone || "",
            },
            <Badge color={statusLabel === "Active" ? "green" : "gray"}>
              {statusLabel}
            </Badge>,
          ],
        };
      }),
    [users]
  );

  const hasData = rows.length > 0;

  /* ---------------- UI ---------------- */
  return (
    <div className="space-y-4">
      <SectionCard title="ARP User Accounts">
        <div className="hidden lg:flex justify-end">
          <RefreshButton onClick={() => fetchUsers(currentPage)} />
        </div>

        {/* LOADING */}
        {loading && (
          <div className="py-8 flex justify-center">
            <RegularLoader />
          </div>
        )}

        {/* NO DATA */}
        {!loading && !hasData && (
          <div className="py-10 text-center">
            <p className="text-sm font-semibold text-slate-600">
              No retailer users found
            </p>
            <p className="mt-1 text-xs text-slate-500">
              Retailer user accounts will appear here once created.
            </p>
          </div>
        )}

        {/* TABLE */}
        {!loading && hasData && (
          <SimpleTable
            headers={[
              "User",
              "Name",
              "Role",
              "Created By",
              "Status",
            ]}
            rows={rows}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            renderActions={(u) => (
              <button
                disabled={updatingId === u.id}
                onClick={() => handleToggleUserStatus(u)}
                className="text-[10px] px-2 py-0.5 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100 disabled:opacity-50"
              >
                {updatingId === u.id
                  ? "Updating..."
                  : u.status === 1
                  ? "Deactivate"
                  : "Activate"}
              </button>
            )}
          />
        )}
      </SectionCard>

      <SectionCard title="How this maps to Retailer User Portal">
        <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
          <li>Admin / Company can see all retailer users linked to retailers.</li>
          <li>Deactivating a user blocks login while preserving history.</li>
        </ul>
      </SectionCard>
    </div>
  );
}



// import { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import { Badge } from "../../../Component/AdminComponents/Badge";
// import { SectionCard } from "../../../Component/AdminComponents/SectionCard";
// import { BASE_URL } from "../../../config/api";
// import SimpleTable from "../../../Component/Common/SimpleTable";
// import RefreshButton from "../../../Component/Common/RefreshButton";

// export default function RetailerUsersView() {
//   const authUser = JSON.parse(localStorage.getItem("authUserData"));
//   const role = Number(authUser?.role);
//   const companyId = authUser?.id;

//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // ----------------------------------
//   // FETCH USERS
//   // ----------------------------------
//   const fetchUsers = async (page = 1) => {
//     try {
//       setLoading(true);

//       let url = `${BASE_URL}common/get-users?role=6&page=${page}`;

//       if (role === 2 && companyId) {
//         url += `&company_id=${companyId}`;
//       }

//       const res = await axios.get(url);

//       if (res.data?.status) {
//         setUsers(res.data.data || []);

//         setCurrentPage(res.data.pagination?.current_page || 1);
//         setTotalPages(res.data.pagination?.last_page || 1);
//       }
//     } catch (err) {
//       console.error("Failed to load retailer users", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers(currentPage);
//   }, [role, companyId, currentPage]);

//   // ----------------------------------
//   // TOGGLE STATUS (UI ONLY)
//   // ----------------------------------
//   const handleToggleUserStatus = (id) => {
//     setUsers((prev) =>
//       prev.map((u) =>
//         u.id === id
//           ? {
//               ...u,
//               status: u.status === 1 ? 0 : 1,
//             }
//           : u
//       )
//     );
//   };

//   // ----------------------------------
//   // TABLE ROWS (SimpleTable format)
//   // ----------------------------------
//   const rows = useMemo(
//     () =>
//       users.map((u) => {
//         const statusLabel = u.status === 1 ? "Active" : "Inactive";

//         return {
//           raw: u,
//           cells: [
//             {
//               title: u.owner_email || u.contact_email || "-",
//               sub: u.owner_contact || u.contact_phone || "",
//             },
//             u.business_name || "-",
//             "Retailer User",
//             <Badge color={statusLabel === "Active" ? "green" : "gray"}>
//               {statusLabel}
//             </Badge>,
//             u.updated_at
//               ? new Date(u.updated_at).toLocaleString()
//               : "-",
//           ],
//         };
//       }),
//     [users]
//   );

//   return (
//     <div className="space-y-4">
//       <SectionCard title="Retailer User Accounts">
//         <div className="flex justify-end">
//           <RefreshButton onClick={fetchUsers}/>
//         </div>
//         <SimpleTable
//           headers={[
//             "User",
//             "Retailer",
//             "Role",
//             "Status",
//             "Last Login",
//           ]}
//           rows={loading ? [] : rows}
//           currentPage={currentPage}
//           totalPages={totalPages}
//           onPageChange={setCurrentPage}
//           renderActions={
//             loading
//               ? null
//               : (u) => (
//                   <button
//                     onClick={() => handleToggleUserStatus(u.id)}
//                     className="text-[10px] px-2 py-0.5 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100"
//                   >
//                     {u.status === 1 ? "Deactivate" : "Activate"}
//                   </button>
//                 )
//           }
//         />

//       </SectionCard>

//       <SectionCard title="How this maps to Retailer User Portal">
//         <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
//           <li>
//             Admin / Company can see all retailer users linked to retailers.
//           </li>
//           <li>
//             Deactivating a user blocks login while preserving history.
//           </li>
//         </ul>
//       </SectionCard>
//     </div>
//   );
// }





// import { useState } from "react";
// import { Badge } from "../../../Component/AdminComponents/Badge";
// import { SectionCard } from "../../../Component/AdminComponents/SectionCard";

// const retailerUsers = [
//   {
//     id: 1,
//     retailerName: "Shree Mobile Store",
//     userName: "store.owner@shreemobile.in",
//     role: "Admin",
//     status: "Active",
//     lastLogin: "2025-11-14 11:20",
//   },
//   {
//     id: 2,
//     retailerName: "Shree Mobile Store",
//     userName: "cashier1@shreemobile.in",
//     role: "Cashier",
//     status: "Active",
//     lastLogin: "2025-11-15 09:05",
//   },
//   {
//     id: 3,
//     retailerName: "A1 Electronics",
//     userName: "owner@a1electronics.com",
//     role: "Admin",
//     status: "Inactive",
//     lastLogin: "2025-10-30 18:40",
//   },
// ];

// export default function RetailerUsersView() {

//   const [retailerUserList, setRetailerUserList] = useState(retailerUsers);

//   const handleToggleUserStatus = (id) => {
//     setRetailerUserList((prev) =>
//       prev.map((u) =>
//         u.id === id
//           ? {
//               ...u,
//               status: u.status === "Active" ? "Inactive" : "Active",
//             }
//           : u
//       )
//     );
//   };
//   return (
//     <div className="space-y-4">
//       <SectionCard title="Retailer User Accounts">
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-xs">
//             <thead>
//               <tr className="border-b border-slate-100 text-slate-500">
//                 <th className="py-2 text-left">User</th>
//                 <th className="py-2 text-left">Retailer</th>
//                 <th className="py-2 text-left">Role</th>
//                 <th className="py-2 text-left">Status</th>
//                 <th className="py-2 text-left">Last Login</th>
//                 <th className="py-2 text-left">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {retailerUserList.map((u) => (
//                 <tr
//                   key={u.id}
//                   className="border-b border-slate-50 bg-white hover:bg-blue-50/60"
//                 >
//                   <td className="py-1.5 text-xs text-slate-700">
//                     <div className="font-semibold">{u.userName}</div>
//                   </td>
//                   <td className="py-1.5 text-xs text-slate-700">{u.retailerName}</td>
//                   <td className="py-1.5 text-[11px] text-slate-700">{u.role}</td>
//                   <td className="py-1.5 text-xs">
//                     <Badge color={u.status === "Active" ? "green" : "gray"}>
//                       {u.status}
//                     </Badge>
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">{u.lastLogin}</td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     <button
//                       onClick={() => handleToggleUserStatus(u.id)}
//                       className="text-[10px] px-2 py-0.5 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100"
//                     >
//                       {u.status === "Active" ? "Deactivate" : "Activate"}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </SectionCard>

//       <SectionCard title="How this maps to Retailer User Portal">
//         <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
//           <li>
//             Admin can see which retailer users are active / inactive and what access
//             they have (e.g. create warranty, view warranty, download certificates,
//             see legal pages).
//           </li>
//           <li>
//             Deactivating a user here should block login in retailer user portal but
//             keep historical records linked.
//           </li>
//         </ul>
//       </SectionCard>
//     </div>
//   );
// }
